import { useQuery } from "@tanstack/react-query";
import { vacancyService } from "@/services/vacancyService";

// Query keys
export const vacancyQueryKeys = {
    all: ["vacancy"],
    list: () => [...vacancyQueryKeys.all, "list"],
    details: (id) => [...vacancyQueryKeys.all, "detail", id],
    create: () => [...vacancyQueryKeys.all, "create"],
};

// get all vacancies
export const useAllVacancies = (params) => {
    return useQuery({
        queryKey: vacancyQueryKeys.list(),
        queryFn: () => vacancyService.getAllVacancies(params),
    });
};

// get vacancy by campaign id
export const useVacancyByCampaignId = (campaignId, params) => {
  return useQuery({
    queryKey: [...vacancyQueryKeys.details(campaignId), 'campaign'],
    queryFn: () => vacancyService.getVacancyByCampaignId(campaignId, params),
    enabled: !!campaignId, // Only fetch if campaignId is provided
  });
};

// get vacancy by id
export const useVacancyById = (vacancyId) => {
  return useQuery({
    queryKey: [...vacancyQueryKeys.details(vacancyId)],
    queryFn: () => vacancyService.getVacancyById(vacancyId),
    enabled: !!vacancyId,
  });
};

// get company vacancies
export const useCompanyVacancies = (companyId, params) => {
  return useQuery({
    queryKey: [...vacancyQueryKeys.details(companyId)],
    queryFn: () => vacancyService.getCompanyVacancies(companyId, params),
    enabled: !!companyId,
  });
};

// get all vacancies by company id
export const useAllVacanciesByCompanyId = (companyId) => {
  return useQuery({
    queryKey: [...vacancyQueryKeys.details(companyId)],
    queryFn: () => vacancyService.getAllVacanciesByCompanyId(companyId, { status: [0, 1] }),
    enabled: !!companyId,
  });
};

// get vacancies using getVacancies API
export const useVacancies = (companyId, params) => {
  return useQuery({
    queryKey: [...vacancyQueryKeys.details(companyId), 'listing'],
    queryFn: () => vacancyService.getVacancies(companyId, params),
    enabled: !!companyId,
  });
};

